<div class="d-grid align-content-center route-container">
    <div class="route-content justify-content-center">
        <div class="route-page-container" [style.margin-top]="progressBar === true ? '20px' : '24px'">
            @if (introContent || intro || introConfirm || introSub) {
            <div class="psic-mx-3 d-grid animate-header justify-content-center">
                @if (introContent) {
                <h3 [innerHTML]="introContent" class="text-center mb-1 mobile"></h3>
                } @if (introContent) {
                <h2 [innerHTML]="introContent" class="text-center mb-2 desktop"></h2>
                }
                <h5 [innerHTML]="intro" class="text-center mobile"></h5>
                <h5 [innerHTML]="introConfirm" class="text-center mobile"></h5>
                <h2 [innerHTML]="intro" class="text-center desktop" [style.maxWidth]="introTextMaxWidth"></h2>
                <h3 [innerHTML]="introConfirm" class="text-center desktop" [style.maxWidth]="introConfirmMaxWidth"></h3>
                <p [innerHTML]="introSub" class="text-center p-1" [style.maxWidth]="introSubMaxWidth"></p>
                <!-- Use Bootstrap classes -->
            </div>
            }
            <div class="psic-mx-6 psic-mt-8 animate-content">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
    <div>
        <ng-content select="[footer]"></ng-content>
    </div>
</div>
